import {Modal} from 'react-bootstrap'

export const CheckModal = (props: any) => {
  return (
    <Modal
      show={props.modalState}
      dialogClassName='ePulse-modal ePulse-modal-50w'
      onHide={() => props.closeModal()}
      backdrop='static'
    >
      <Modal.Header className='border-0' closeButton>
        <span className='fs-3 fw-bold'>Are you sure you want to change the status?</span>
      </Modal.Header>
      <Modal.Body className='container' />
      <div className='ePulse-modal-content'>

        <div className='d-flex justify-content-end gap-3'>
          <button className='ePulse-btn-primary' type='button' onClick={() =>props.onCancel()}>Cancel</button>
       <button className='ePulse-btn-primary' type='button' onClick={() =>props.onDone()}>
        Okay
       </button>
        </div>
      </div>
    </Modal>
  )
}